import React from 'react';
import PropTypes from 'prop-types';
import Icon from '../../../component/Icon';
import './style.scss';

Title.propTypes = {
  title: PropTypes.string,
  highlight: PropTypes.string
};

export function Title({ title, highlight }) {
  return (
    <article className="title">
      <Icon name="title_point" />
      <h1>{title}</h1>
      {
        !!highlight && <p className="highlight">{highlight}</p>
      }
    </article>
  );
}
